module.exports = __webpack_public_path__ + "static/img/circle.66cb65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/student-smart/circle.png
// module id = qgFt
// module chunks = 1